import { getCachedDateOfNow } from "#web/utils/getCachedDateOfNow";
import * as v from "valibot";

const LeakSource = v.object({
  name: v.string(),
  url: v.string(),
});
export type LeakSource = v.InferOutput<typeof LeakSource>;

export const LeakedCode = v.object({
  code: v.string(),
  codeEndsAt: v.nullable(v.date()),
  codeStartsAt: v.nullable(v.date()),
  id: v.string(),
  isCurrentlyLeaked: v.boolean(),
  isHighRisk: v.boolean(),
  lastScrapedAt: v.nullable(v.date()),
  leakedAt: v.date(),
  leakedOnAppInstallation: v.boolean(),
  leakedSiteMetadata: v.nullable(v.record(v.string(), v.unknown())),
  shopId: v.string(),
  shopifyDiscountCodeId: v.nullable(v.string()),
  shopifyPriceRuleId: v.nullable(v.string()),
  sources: v.array(LeakSource),
  value: v.number(),
  valueType: v.nullable(v.string()),
});
export type LeakedCode = v.InferOutput<typeof LeakedCode>;

export const leakedCodeExists = (leakedCode: LeakedCode) => {
  return leakedCode.shopifyDiscountCodeId !== null;
};

export const leakedCodeIsActive = (leakedCode: LeakedCode) => {
  return (
    leakedCode.codeEndsAt === null ||
    (leakedCode.codeEndsAt.getTime() > getCachedDateOfNow().getTime() &&
      (leakedCode.codeStartsAt === null || leakedCode.codeStartsAt.getTime() < getCachedDateOfNow().getTime()))
  );
};

export const leakedCodeEndedBeforeLeak = (leakedCode: LeakedCode) => {
  return leakedCode.codeEndsAt !== null && leakedCode.codeEndsAt.getTime() < leakedCode.leakedAt.getTime();
};

export const leakedCodeStartedAfterLeak = (leakedCode: LeakedCode) => {
  return leakedCode.codeStartsAt !== null && leakedCode.codeStartsAt.getTime() > leakedCode.leakedAt.getTime();
};
